import { axiosInstance, baseURL } from "./auth";
export const getListCountry = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/country/filter_list`, params);
    if (response.data.status_code !== 200) {
        throw new Error(response.data.message)
    }
    return response.data;
};
export const getListState = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/state/filter_list`, params);
    if (response.data.status_code !== 200) {
        throw new Error(response.data.message)
    }
    return response.data;
};